import React, { useEffect, useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import EventEmitter from 'utils/events';
import { EventEmitterTypes } from 'utils/constants';
import './CategoryVisibilitySensor.scss';

function dispatchVisibleCategory(isVisible, visibleElement, headerOpen) {
  if (isVisible && visibleElement && headerOpen) {
    EventEmitter.dispatch(EventEmitterTypes.TOGGLE_VISIBLE_CATEGORY, { categoryId: visibleElement.props.category.id });
  }
}

export function CategoryVisibilitySensor(props) {
  const { scrollDelay, intervalDelay, visibleElement, selectedCategoryLoading, headerOpen } = props;
  const [visibility, setVisibility] = useState(false);
  // Dispatch category Id if category is visible
  const onChangeCallback = isVisible => {
    setVisibility(isVisible);
    dispatchVisibleCategory(isVisible, visibleElement, headerOpen);
  };
  const skeletonHeader = (
    <div className="skeleton-category-header">
      <div className="mock-label" />
    </div>
  );
  useEffect(() => {
    dispatchVisibleCategory(visibility, visibleElement, headerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerOpen]);

  return (
    <VisibilitySensor onChange={onChangeCallback} intervalDelay={intervalDelay || 0} scrollDelay={scrollDelay || 0}>
      {selectedCategoryLoading ? skeletonHeader : visibleElement}
    </VisibilitySensor>
  );
}

export default CategoryVisibilitySensor;
